import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { StartupService } from '@core/startup/startup.service/startup.service';

/**
 * Sends every navigation to /init-error while the app is unusable — either the
 * initialization failed (settings or startup language could not be fetched) or
 * the deployment declared a technical break (see StartupService). Guards each
 * top-level route; the rest of the app would render untranslated keys, so the
 * user must stay on the error page.
 */
export const initErrorGuard: CanActivateFn = () => {
  const startup = inject(StartupService);
  const router = inject(Router);
  return startup.isBlocked() ? router.createUrlTree(['/init-error']) : true;
};

/** Keeps users away from /init-error when the app started up fine. */
export const initErrorPageGuard: CanActivateFn = () => {
  const startup = inject(StartupService);
  const router = inject(Router);
  return startup.isBlocked() ? true : router.createUrlTree(['/']);
};
